import React from 'react';
import ReactDom from 'react-dom';
import  './mtModal.scss';

class MtModal extends React.Component {
  leftButtonAction() {
    if (typeof this.props.lFunc === 'function') {
      dismiss();
      this.props.lFunc();
      return;
    }
    dismiss();
  }
  rightButtonAction() {
    if (typeof this.props.rFunc === 'function') {
      dismiss();
      this.props.rFunc();
      return;
    }
    dismiss();
  }
  handleMaskClick( ){
    if (this.props.maskClickClose) {
      dismiss();
    }
  }
  render() {
    let buttons;
    if (this.props.buttons.length === 1) {
      buttons =  <div className='mt-confirm-singleButton' onClick={() => this.leftButtonAction()}>
        {this.props.buttons[0].text}
      </div> ;
    } else {
      buttons =
      <React.Fragment>
        <div className='mt-confirm-leftButton' onClick={() => this.leftButtonAction()}>
          {this.props.buttons[0].text}
        </div>
        <div className='mt-confirm-rightButton'  onClick={() => this.rightButtonAction()}>
          {this.props.buttons[1].text}
        </div>
      </React.Fragment>;
    }
    return this.props.pop ?
    <React.Fragment>
      <div className='modalWrapper'>
        {
          this.props.options.title &&
          <p className='mt-confirm-title' >{this.props.options.title}</p>
        }
        <div className='mt-confirm-content'>
           { this.props.content }
        </div>
        { this.props.options.needButton && this.props.buttons && this.props.buttons.length > 0 &&
          <div className='mt-confirm-buttons'>
            { buttons }
          </div>
        }
      </div>
      <div className='mt-mask' onClick={() => this.handleMaskClick()}></div>
    </React.Fragment>
     : null;
  }
}
function pop(content, buttons , options = {}, lFunc, rFunc) {
  const container = document.createElement('div');
  container.className = 'modalContainer';
  document.body.append(container);
  if (!buttons || !Array.isArray(buttons) || buttons.length === 0) {
    buttons = [
      { text: '确定' },
    ];
  }
  const defaultOptions = {
    needButton: true,
    maskClickClose: true,
  };
  Object.assign(defaultOptions, options);
  const props = {
    pop: true,
    content,
    buttons,
    options: defaultOptions,
    lFunc,
    rFunc,
  };
  ReactDom.render(<MtModal {...props}/>, container);
}
function popConfirm(content, buttons, options = {}, lFunc, rFunc) {
  if (!buttons) {
    buttons = [
      {text: '取消'},
      {text: '确定'},
    ];
  }
  pop(content, buttons , options, lFunc, rFunc);
}
function dismiss() {
  const container = document.getElementsByClassName('modalContainer')[0];
  document.body.removeChild(container);
}
export default {
  pop,
  popConfirm,
}
